import { useToast } from 'vue-toast-notification';
import { useLoading } from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

let toast = null;
let $loading = null;
let loader = null;

// Lazy initialization to avoid calling composables outside component setup context
function ensureInitialized() {
  if (!toast) {
    toast = useToast();
  }
  if (!$loading) {
    $loading = useLoading();
  }
}

export const utilFunctionService = {
    setLocalStorageService(keyname, value) {
        localStorage.setItem(keyname, value);
    },

    getLocalStorageService(keyname) {
        if (localStorage.getItem(keyname) != 'undefined') {
            return JSON.parse(localStorage.getItem(keyname));
        } else {
            return false;
        }
    },

    currentUserId(){
        if (this.getLocalStorageService('user')) {
            return this.getLocalStorageService('user').users.id;
        } else {
            return false;
        }
    },

    getAuthToken() {
        if (this.getLocalStorageService('user')) {
            return this.getLocalStorageService('user').authorization_token;
        } else {
            return false;
        }
    },

    getUserRoles() {
      if (this.getLocalStorageService('user')) {
          return this.getLocalStorageService('user').users.attributes.user_roles;
      } else {
          return false;
      }
    },

    removeLocalStorageService(keyname) {
        localStorage.removeItem(keyname);
    },

    removeSessionStorageService(keyname) {
        sessionStorage.removeItem(keyname);
    },

    showLoader() {
        ensureInitialized();
        loader = $loading.show({
            canCancel: true,
            color: '#3dbc9e',
            loader: 'spinner',
            width: 40,
            height: 40
        });
    },

    hideLoader() {
        if (loader) {
            loader.hide()
        }
    },

    showSuccess(message) {
        ensureInitialized();
        toast.success(message, {
            position: 'top',
            duration: 5000
        });
    },

    showErr(message) {
        ensureInitialized();
        toast.error(message, {
            position: 'top',
            duration: 5000
        });
    },

    getImageUrl() {
        let url = process.env.VUE_APP_URL
        return url.replace('api/', '')
    },

    bytesToSize(bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]}`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
    },

    sessionExpire(message) {
      this.removeLoalStorageService("user");
      this.showErr(message);
    },
    replaceLearnerToken(text, firstName) {
        return text.replace(
          "[learner-name]",
          firstName
        );
    }
}
